import React from 'react';
import { connect } from 'react-redux';
import { JobTaskCard } from '../Detail';

const JobTaskCards = ({ project, projectTasks, handleEdit }) => {
  return(
    <div>
      {projectTasks &&
        projectTasks.map((task, i) => {
          return <JobTaskCard key={i} task={task} handleEdit={handleEdit}/>;
        })
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const id = props.project.id;
  return ({
    projectTasks: state.projectTasksState.filter( projectTask => projectTask.projectId == id)
  });
}

export default connect(mapStateToProps)(JobTaskCards);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobTaskCards.jsx